import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../axios";

export const fetchOrderReviews = createAsyncThunk(
  "reviews/fetchOrderReviews",
  async () => {
    const { data } = await axios.get("/api/reviews");
    return data;
  }
);

export const createReview = createAsyncThunk(
  "reviews/createReview",
  async ({ orderId, rating, comment }) => {
    const { data } = await axios.post(
      `/api/order/${orderId}/review`,
      {
        rating: Number(rating),
        comment: String(comment || ""),
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return data;
  }
);

export const updateReview = createAsyncThunk(
  "reviews/updateReview",
  async ({ orderId, rating, comment }) => {
    const { data } = await axios.put(
      `/api/order/${orderId}/review`,
      {
        rating: Number(rating),
        comment: String(comment || ""),
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return data;
  }
);

export const createAdminResponse = createAsyncThunk(
  "reviews/createAdminResponse",
  async ({ orderId, text }) => {
    const { data } = await axios.post(
      `/api/order/${orderId}/review/admin-response`,
      { text },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return data;
  }
);

const initialState = {
  reviews: {},
  status: "idle",
  error: null,
};

const reviewSlice = createSlice({
  name: "reviews",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchOrderReviews.pending, state => {
        state.status = "loading";
      })
      .addCase(fetchOrderReviews.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.reviews = action.payload.reduce((acc, review) => {
          acc[review.orderId] = review;
          return acc;
        }, {});
      })
      .addCase(fetchOrderReviews.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(createReview.pending, state => {
        state.status = "loading";
      })
      .addCase(createReview.fulfilled, (state, action) => {
        state.status = "succeeded";
        if (action.payload.orderId) {
          state.reviews[action.payload.orderId] = action.payload;
        }
      })
      .addCase(createReview.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(updateReview.pending, state => {
        state.status = "loading";
      })
      .addCase(updateReview.fulfilled, (state, action) => {
        state.status = "succeeded";
        if (action.payload.orderId) {
          state.reviews[action.payload.orderId] = action.payload;
        }
      })
      .addCase(updateReview.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(createAdminResponse.fulfilled, (state, action) => {
        if (state.reviews[action.payload.orderId]) {
          state.reviews[action.payload.orderId].adminResponse =
            action.payload.text;
        }
      });
  },
});

// Expose actions to window object in development
if (process.env.NODE_ENV === "development") {
  window.createReview = createReview;
  window.updateReview = updateReview;
}

export const reviewReducer = reviewSlice.reducer;
